import { Message } from "primereact/message";
import { classNames } from "primereact/utils";

import styles from "./equipe-aviso.module.scss";
import type { EquipeAvisoProps } from "./types-equipe-aviso";

/**
 * Aviso dos diálogos da Etapa Equipe (Figma `message` 12227:420458, 12227:420507, 12227:420621): o texto é 14 e o
 * ícone 16 (`p-message-sm` do tema) e o bloco abraça o texto.
 */
export function EquipeAvisoView({ className, children, text, ...props }: EquipeAvisoProps) {
  return (
    <Message
      {...props}
      text={children ?? text}
      className={classNames("p-message-block", "p-message-sm", styles.aviso, className)}
    />
  );
}
